import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { queryKey as getOrderSummaryForCheckout } from "./useGetOrderSummaryForCheckout";

const orderRepo = OrderRepositoryImpl.getInstance();

const useCreateCheckout = (orderId: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: () => {
        return orderRepo.createCheckout(auth, orderId, apiUrl);
      },
      onSuccess: () => {
        queryClient?.invalidateQueries({
          queryKey: [getOrderSummaryForCheckout],
        });
      },
      onError: () => {
        queryClient?.invalidateQueries({
          queryKey: [getOrderSummaryForCheckout],
        });
      },
    },
    queryClient,
  );

  const createCheckout = useCallback(() => {
    /**
     * TODO We need to use mutateAsync this time to return a promise to handle checkoutId
     * returned from orderRepo.createCheckout and avoid a massive refactor temporally.
     */
    return mutation.mutateAsync();
  }, [mutation]);

  return createCheckout;
};

export { useCreateCheckout };
